module.exports = __webpack_public_path__ + "img/daiquiri.78c9b2a9.jpg";